import { computed } from 'vue';
import useRwdImg from '@/hooks/useRwdImg';

const mainBg = computed(() => useRwdImg('workshop_pc_bg1'));
const playgroundFrame = computed(() => useRwdImg('workshop_pc_mainbg_frame'));
const playgroundBg = computed(() => useRwdImg('workshop_pc_mainbg'));
const shareBtn = computed(() => useRwdImg('workshop_pc_btn_share'));
const getBtn = computed(() => useRwdImg('workshop_pc_btn_get'))
const iconCamera = computed(() => useRwdImg('workshop_pc_icon_camera'));
const iconGift = computed(() => useRwdImg('workshop_pc_icon_gift'));
const iconLinkArrow = computed(() => useRwdImg('workshop_pc_icon_link_arrow'));
const iconErase = computed(() => useRwdImg('workshop_pc_icon_erase'));
const iconEraseGlow = computed(() => useRwdImg('workshop_pc_icon_erase_hover'));
const stickerbox = computed(() => useRwdImg('workshop_pc_sticker_area'));
const stickerboxEffect = computed(() => useRwdImg('workshop_pc_sticker_glow'));
const stickerItem = computed(() => useRwdImg('workshop_pc_sticker_bg'));
const stickerItemEffect = computed(() => useRwdImg('workshop_pc_sticker_bg_glow'));
const stickerImg1 = computed(() => useRwdImg('workshop_pc_sticker1'))
const stickerImg2 = computed(() => useRwdImg('workshop_pc_sticker2'))
const stickerImg3 = computed(() => useRwdImg('workshop_pc_sticker3'))
const scrollArrow = computed(() => useRwdImg('workshop_pc_arrow_down'));
const thumbnailBg = computed(() => useRwdImg('workshop_pc_map_bg'));
const thumbnailBgActive = computed(() => useRwdImg('workshop_pc_map_bg_active'));
const thumbnailMask = computed(() => useRwdImg('workshop_pc_thumbnail_mask'))
const festivalBg = computed(() => useRwdImg('workshop_pc_bg2'));
const festivalBanner = computed(() => useRwdImg('workshop_pc_banner'));
const festivalTitleLine = computed(() => useRwdImg('workshop_pc_title_deco'));
const imageBoxActive = computed(() => useRwdImg('workshop_pc_add_frame_active'))
const imageBox = computed(() => useRwdImg('workshop_pc_add_frame'))
const imageBoxUsed = computed(() => useRwdImg('workshop_pc_add_frame_used'));
const unlockToast = computed(() => useRwdImg('workshop_pc_toast'));

export function useBackgroundUrl() {
  return {
    mainBg: mainBg.value.backgroundUrl,
    playgroundFrame: playgroundFrame.value.backgroundUrl,
    playgroundBg: playgroundBg.value.backgroundUrl,
    shareBtn: shareBtn.value.backgroundUrl,
    getBtn: getBtn.value.backgroundUrl,
    iconCamera: iconCamera.value.backgroundUrl,
    iconGift: iconGift.value.backgroundUrl,
    iconLinkArrow: iconLinkArrow.value.backgroundUrl,
    stickerbox: stickerbox.value.backgroundUrl,
    stickerboxEffect: stickerboxEffect.value.backgroundUrl,
    stickerItem: stickerItem.value.backgroundUrl,
    stickerItemEffect: stickerItemEffect.value.backgroundUrl,
    stickerImg1: stickerImg1.value.backgroundUrl,
    stickerImg2: stickerImg2.value.backgroundUrl,
    stickerImg3: stickerImg3.value.backgroundUrl,
    scrollArrow: scrollArrow.value.backgroundUrl,
    thumbnailBg: thumbnailBg.value.backgroundUrl,
    thumbnailBgActive: thumbnailBgActive.value.backgroundUrl,
    thumbnailMask: thumbnailMask.value.backgroundUrl,
    festivalBg: festivalBg.value.backgroundUrl,
    festivalBanner: festivalBanner.value.backgroundUrl,
    festivalTitleLine: festivalTitleLine.value.backgroundUrl,
    imageBoxActive: imageBoxActive.value.backgroundUrl,
    imageBox: imageBox.value.backgroundUrl,
    imageBoxUsed: imageBoxUsed.value.backgroundUrl,
    iconErase: iconErase.value.backgroundUrl,
    iconEraseGlow: iconEraseGlow.value.backgroundUrl,
    unlockToast: unlockToast.value.backgroundUrl,
  }
}

export function useImgSrc() {
  return {
    mainBg: mainBg.value.imgSrc,
    playgroundFrame: playgroundFrame.value.imgSrc,
    playgroundBg: playgroundBg.value.imgSrc,
    shareBtn: shareBtn.value.imgSrc,
    getBtn: getBtn.value.imgSrc,
    iconCamera: iconCamera.value.imgSrc,
    iconGift: iconGift.value.imgSrc,
    iconLinkArrow: iconLinkArrow.value.imgSrc,
    stickerbox: stickerbox.value.imgSrc,
    stickerboxEffect: stickerboxEffect.value.imgSrc,
    stickerItem: stickerItem.value.imgSrc,
    stickerItemEffect: stickerItemEffect.value.imgSrc,
    stickerImg1: stickerImg1.value.imgSrc,
    stickerImg2: stickerImg2.value.imgSrc,
    stickerImg3: stickerImg3.value.imgSrc,
    scrollArrow: scrollArrow.value.imgSrc,
    thumbnailBg: thumbnailBg.value.imgSrc,
    thumbnailBgActive: thumbnailBgActive.value.imgSrc,
    thumbnailMask: thumbnailMask.value.imgSrc,
    festivalBg: festivalBg.value.imgSrc,
    festivalBanner: festivalBanner.value.imgSrc,
    festivalTitleLine: festivalTitleLine.value.imgSrc,
    imageBoxActive: imageBoxActive.value.imgSrc,
    imageBox: imageBox.value.imgSrc,
    imageBoxUsed: imageBoxUsed.value.imgSrc,
    iconErase: iconErase.value.imgSrc,
    iconEraseGlow: iconEraseGlow.value.imgSrc,
    unlockToast: unlockToast.value.imgSrc,
  }
}
